import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import UnifySidebar from "./sidebar";
import { TopNav } from "../navbar";
import useIsMobile from "../../hook/use-is-mobile";

// Layout shell for the new Convo Unify area — its own sidebar, separate
// from Marketing/CRM/Global Admin. Same off-canvas-on-mobile /
// collapse-to-rail-on-desktop shell used by those.
const UnifyLayout = () => {
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(() => !isMobile);
  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
        setSidebarOpen(false);
      }
    };
    if (sidebarOpen && isMobile) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [sidebarOpen, isMobile]);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <div className="mx-auto flex min-h-screen bg-[#F1F5F9] dark:bg-gray-950 md:h-screen overflow-hidden">
      {sidebarOpen && isMobile && (
        <div className="fixed inset-0 bg-black/40 z-40 md:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <aside
        ref={sidebarRef}
        className={`fixed inset-y-0 left-0 z-50 h-screen w-[275px] transition-all duration-300 md:z-auto md:sticky md:top-0 ${
          sidebarOpen ? "translate-x-0 md:w-[275px]" : "-translate-x-full md:translate-x-0 md:w-[88px]"
        }`}
      >
        <UnifySidebar open={sidebarOpen} onToggle={toggleSidebar} />
      </aside>

      <main id="page-scroll-container" className="flex-1 overflow-y-auto">
        <div className="min-h-full p-4">
          <TopNav onMenuClick={toggleSidebar} />
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default UnifyLayout;
